export enum StoragePersistKeyEnum {
  CurrentUserHotel = '__CurrentUserHotel__',
  RequestActive = '__RequestActive__',
}
